export const ABSENT_LIST = 'ABSENT_LIST';

export default {
    ABSENT_LIST
};
